import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { styleCss } from "components/layout/utils";

import Block, { IBlockProps } from "./Block";

export interface IFlexProps extends IBlockProps {
  inline?: boolean;
  column?: boolean;
  reverse?: boolean;
  flexWrap?: boolean;
  gap?: string;
  justifyContent?: "flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "space-evenly";
  alignContent?: "flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "stretch";
  alignItems?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch" | "initial" | "self-end";
  alignSelf?: "normal" | "self-start" | "self-end" | "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
}

const Flex = styled(Block)<IFlexProps>`
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.inline ? "inline-flex" : "flex")
  };
  flex-direction: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => `${props.column ? "column" : "row"}${props.reverse ? "-reverse" : ""}`
  };
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.flexWrap &&
      css`
        flex-wrap: wrap;
      `
  };

  ${styleCss("justifyContent")};
  ${styleCss("alignContent")};
  ${styleCss("alignItems")};
  ${styleCss("alignSelf")};
  ${styleCss("gap")};
`;

export default Flex;
